export const PAGE_ROUTES = ['/', '/projects', '/activity', '/art', '/cv'];

export function getSwipeDestination(pathname, deltaX, deltaY) {
  if (Math.abs(deltaX) < 60 || Math.abs(deltaX) <= Math.abs(deltaY) * 1.25) {
    return null;
  }

  const currentIndex = PAGE_ROUTES.indexOf(pathname);
  if (currentIndex === -1) return null;

  const nextIndex = deltaX < 0 ? currentIndex + 1 : currentIndex - 1;
  return PAGE_ROUTES[nextIndex] ?? null;
}
